import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const shareDashboard = (
    mailingListId: string[],
    dashboardId: string,
    surveyId: string,
    successMessage: string,
    errorMessage: string,
    selectedSchema: string,
) => {
    const requestOptions = {
        method: 'POST',
        headers: generateHeaders(selectedSchema),
    };

    mailingListId.map((mailingList) => fetch(`${process.env.REACT_APP_API_URL}/mailing_list/${mailingList}/share/survey/${surveyId}/dashboard/${dashboardId}`, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');
            } else {
                displayToast(successMessage, 'success');
            }
        }).catch(() => {
            displayToast(errorMessage, 'error');
        }));
};

export default shareDashboard;
